var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxOpen = function SvgBoxOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72 8.49c-.302.6.02 1.327.663 1.511l5.47 1.565a1.07 1.07 0 0 0 1.212-.48l2.797-4.655-8.2-1.025a.54.54 0 0 0-.546.291zm10.142-2.059 2.793 4.656a1.07 1.07 0 0 0 1.213.479L22.337 10A1.07 1.07 0 0 0 23 8.491l-1.393-2.794a.53.53 0 0 0-.546-.29zm6.966 5.403v5.13l-6.162 1.541V10.45a.8.8 0 0 0-.804-.804.8.8 0 0 0-.804.804v8.055l-6.163-1.54v-5.131l-1.608-.46v5.594c0 .737.503 1.38 1.22 1.56l6.836 1.71c.341.083.7.083 1.038 0l6.836-1.71a1.606 1.606 0 0 0 1.22-1.56v-5.593z"
  })));
};
export default SvgBoxOpen;